{
  "positionInfo": {
    "title": "Открытая позиция",
    "type": "Тип",
    "quantity": "Количество",
    "quantityAndSharesPerContract": "Количество (лот х100)",
    "currentCost": "Текущая стоимость",
    "profitabilityInDollar": "Доходность в $",
    "balanceSheet": "Балансовая стоимость",
    "entryPrice": "Цена входа",
    "profitabilityInPercent": "Доходность в %",
    "share": "Доля, %",
    "dropdownTitle": "Информация о позиции",
    "currentPrice": "Текущая цена",
    "profitToday": "За сегодня",
    "profitAllTime": "За все время",
    "USD": "USD",
    "side": {
      "buy": "Купить",
      "sell": "Продать"
    },
    "option": "Опцион",
    "strike": "Страйк",
    "expiration": "Экспирация",
    "assetsInfoFailed": "Не удалось получить информацию об акции опциона"
  }
}
